import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IContact } from "src/app/models/contact/contact";

@Component({
  selector: "app-contact-list",
  templateUrl: "./contact-list.component.html",
  styleUrls: ["./contact-list.component.scss"],
})
export class ContactListComponent {
  @Input() contacts: IContact[] = [];
  @Input() isLoading = false;

  readonly skeletonRows = Array.from({ length: 6 });

  @Output() sendToContactClick = new EventEmitter<IContact>();
  @Output() editContactClick = new EventEmitter<IContact>();
  @Output() deleteContactClick = new EventEmitter<IContact>();

  get doesContactsExist() {
    return this.contacts.length > 0;
  }

  get contactsByAlphabet() {
    const dictionary: Record<string, IContact[]> = {};

    for (let contact of this.contacts) {
      const contactNameFirstChar = contact.name.charAt(0).toUpperCase();

      if (contactNameFirstChar in dictionary) {
        dictionary[contactNameFirstChar].push(contact);
      } else {
        dictionary[contactNameFirstChar] = [contact];
      }
    }

    for (let key of Object.keys(dictionary)) {
      dictionary[key].sort((c1, c2) => c1.name.localeCompare(c2.name));
    }

    return dictionary;
  }
}
